import clsx from "clsx";

import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";
import { usePrettyLogEventPage } from "@components/v2/analytics";
import { FilterButtonActive } from "@features/sales-v3/top-level-filters/components/filter-button-active";
import { FilterButtonSelect } from "@features/sales-v3/top-level-filters/components/filter-button-select";
import { formatDateRange } from "@features/sales-v3/utils/format-date-range";

import { useLandingPageAnalyticsContext } from "../hooks";

import { DateFilters } from "./date-filters";

export const FiltersBar = () => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { value: breakdownConfigs } = useSalesBreakdownConfigs();
  const {
    filters: {
      attributionModel,
      attributionWindow,
      accountingMode,
      level,
      dateRange,
      dateRangeInterval,
      breakdownFilters,
      adQuery,
      urlQuery,
      advancedSearch,
    },
    setBreakdownFilters,
    setPage,
  } = useLandingPageAnalyticsContext();

  const pageContext = {
    attributionModel,
    attributionWindow,
    accountingMode,
    level,
    dateRange,
    breakdownFilters,
    adQuery,
    urlQuery,
    advancedSearch,
  };

  return (
    <div className="px-6 py-4 text-xs flex justify-between">
      <div className="flex shrink-0 gap-6">
        <div>
          <div
            className={clsx(
              "text-xs text-interstellar+2 mb-1",
              "leading-4 tracking-[0.025em] mt-[3px] cursor-default",
            )}
          >
            FILTER BY
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {breakdownFilters.map((e) => (
              <FilterButtonActive
                key={e.key}
                breakdown={e}
                onDelete={() => {
                  const newFilters = breakdownFilters.filter(
                    (v) => v.key !== e.key,
                  );

                  prettyLogEventPage({
                    domain: "Landing Page Analytics",
                    action: "onClick",
                    additionalActionInfo: "Delete Page Filters",
                    data: {
                      newFilters,
                      pageContext,
                    },
                  });

                  setPage(1);
                  setBreakdownFilters(newFilters);
                }}
              />
            ))}
            <FilterButtonSelect
              breakdownConfigs={breakdownConfigs}
              breakdowns={breakdownFilters}
              onChange={(value) => {
                prettyLogEventPage({
                  domain: "Landing Page Analytics",
                  action: "onChange",
                  additionalActionInfo: "Change Page Filters",
                  data: {
                    newFilters: value,
                    pageContext,
                  },
                });

                setPage(1);
                setBreakdownFilters(value);
              }}
            />
          </div>
        </div>
        <div className="text-xs">
          <div
            className={clsx(
              "text-xs text-interstellar+2 mb-[5px]",
              "leading-4 tracking-[0.025em] mt-[3px] cursor-default",
            )}
          >
            TIME PERIOD
            <span className="ml-2 text-gray+1">
              {formatDateRange(dateRangeInterval)}
            </span>
          </div>
          <DateFilters />
        </div>
      </div>
    </div>
  );
};
